import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { ApplicationState } from 'store';

export function useThunkDispatch() {
    return useDispatch<ThunkDispatch<ApplicationState, undefined, AnyAction>>();
}
